import { makeStyles } from '@mui/styles';

import theme from 'src/theme';
import { MAX_CHANGE_SCREEN_WIDTH } from 'src/pages/game-new2/constants';
import { windowsSizeParams } from 'src/consts/window-size-params';

export const useStyles = makeStyles({
    dialogMainWrapper: {
        width: 'fit-content',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 5,
        right: 5,
        gridGap: '10px',
        zIndex: 201,
        alignItems: 'flex-end',
        [theme.breakpoints.up(MAX_CHANGE_SCREEN_WIDTH)]: {
            '@media screen  and (orientation: landscape) ': {
                top: windowsSizeParams.desktopAppBarHeight,
            },
        },
    },
});
